<template>
  <b class="text-success">
    (
    <slot>automatycznie</slot>)
  </b>
</template>

<script>
export default {
  name: 'w-auto-text',
  data() {
    return {};
  }
};
</script>

<style>
</style>